import { render, staticRenderFns } from "./ProcurementsChart.vue?vue&type=template&id=2399c78a"
import script from "./ProcurementsChart.vue?vue&type=script&lang=js"
export * from "./ProcurementsChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports